import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { useEffect } from "react";

// Pages
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import DataEntry from "./pages/DataEntry";
import Lifestyle from "./pages/Lifestyle";
import AuthCallback from "./pages/AuthCallback";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import FAQ from "./pages/FAQ";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import SetupPassword from "./pages/SetupPassword";
import Profile from "./pages/Profile";
import VerifyEmail from "./pages/VerifyEmail";
import Education from "./pages/Education";
import NotFound from "./pages/NotFound";

// Hide Emergent badge
const HideBadge = () => {
  useEffect(() => {
    const hideBadge = () => {
      const badge = document.querySelector('a[href*="emergentagent.com"]');
      if (badge) {
        const parent = badge.parentElement;
        if (parent) parent.style.display = 'none';
        badge.style.display = 'none';
      }
    };
    hideBadge();
    const interval = setInterval(hideBadge, 500);
    return () => clearInterval(interval);
  }, []);
  return null;
};

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment (not query params) for session_id
  // Detect session_id during render (NOT in useEffect) to prevent race conditions
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/data-entry" element={<DataEntry />} />
      <Route path="/lifestyle" element={<Lifestyle />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/setup-password" element={<SetupPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/education" element={<Education />} />
      <Route path="/education/:topicId" element={<Education />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <HideBadge />
        <AppRouter />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
